// For fetch data
export const FETCH_SLA_REQUEST = "FETCH_SLA_REQUEST";
export const FETCH_SLA_REQUEST_SUCCESS = "FETCH_SLA_REQUEST_SUCCESS";
export const FETCH_SLA_REQUEST_FAILER = "FETCH_SLA_REQUEST_FAILER";


// For create data
export const CREATE_SLA_REQUEST = "CREATE_SLA_REQUEST";
export const CREATE_SLA_REQUEST_SUCCESS = "CREATE_SLA_REQUEST_SUCCESS";
export const CREATE_SLA_REQUEST_FAILER = "CREATE_SLA_REQUEST_FAILER";

